/*global googletag, window*/

import "babel-polyfill";
import { LoadAmazonAds } from './amazon.js';
import { LoadPrebidAds } from './prebid.js';

export const LoadProgrammaticAds = async (slots) => {
  await Promise.all([LoadAmazonAds(slots), LoadPrebidAds(slots)]);
  googletag.cmd.push(() => {
    googletag.pubads().refresh(slots);
  });
};



// WEBPACK FOOTER //
// ./shared_critical/media/programmatic.js